/* ============================================================
   VW · App JS
   Vanilla, no framework. Loaded with `defer` from theme.liquid.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Announcement bar ---------- */
  const ann = document.querySelector('[data-vw-announcement]');
  if (ann) {
    const ANN_KEY = 'vw-ann-dismissed';
    const annId = ann.querySelector('strong')?.textContent || 'default';
    if (localStorage.getItem(ANN_KEY) === annId) ann.style.display = 'none';
    ann.querySelector('[data-vw-announcement-close]')?.addEventListener('click', () => {
      ann.style.display = 'none';
      localStorage.setItem(ANN_KEY, annId);
    });
  }

  /* ---------- Countdown ---------- */
  document.querySelectorAll('[data-vw-countdown]').forEach((el) => {
    const endAttr = el.getAttribute('data-vw-countdown-end');
    const $h = el.querySelector('[data-vw-cd-h]');
    const $m = el.querySelector('[data-vw-cd-m]');
    const $s = el.querySelector('[data-vw-cd-s]');
    function endOfDay() { const d = new Date(); d.setHours(23, 59, 59, 999); return d; }
    // A fixed ISO end date (e.g. a one-off restock-hype countdown) is
    // computed once and stays fixed. When no end date is set, recompute
    // "end of today" fresh on every tick instead of once at setup — that
    // way once one day's midnight passes, the next tick naturally targets
    // the following midnight instead of freezing at 00:00:00.
    const fixedEnd = endAttr ? new Date(endAttr) : null;
    function tick() {
      const endTime = fixedEnd || endOfDay();
      const d = Math.max(0, endTime - new Date());
      $h.textContent = String(Math.floor(d / 3600000)).padStart(2, '0');
      $m.textContent = String(Math.floor((d % 3600000) / 60000)).padStart(2, '0');
      $s.textContent = String(Math.floor((d % 60000) / 1000)).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('[data-vw-faq-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.vw-faq-item');
      const open = item.classList.toggle('vw-faq-item--open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Featured product thumbs ---------- */
  document.querySelectorAll('.vw-feat-gallery').forEach((gallery) => {
    const mainImg = gallery.querySelector('.vw-feat-main img');
    const thumbs = gallery.querySelectorAll('[data-vw-thumb]');
    thumbs.forEach((t) => {
      t.addEventListener('click', () => {
        thumbs.forEach((x) => x.classList.remove('vw-feat-thumb--active'));
        t.classList.add('vw-feat-thumb--active');
        const img = t.querySelector('img');
        if (mainImg && img) {
          mainImg.src = img.src;
          mainImg.srcset = img.srcset || '';
        }
      });
    });
  });

  /* ---------- WhatsApp bubble auto-hide + close ---------- */
  const bubble = document.querySelector('[data-vw-wa-bubble]');
  if (bubble) {
    setTimeout(() => bubble.style.display = 'none', 8000);
    bubble.querySelector('[data-vw-wa-bubble-close]')?.addEventListener('click', () => {
      bubble.style.display = 'none';
    });
  }

  /* ============================================================
     CART — count updates, AJAX add.

     SIDE CART DISABLED (merchant request): the slide-out cart drawer
     never opens anywhere on the site. Every control that used to
     open it (header cart icon, "View cart" buttons, anything marked
     data-vw-cart-open) now takes the customer to the full /cart page
     instead, which is styled to match the theme and enforces the
     bundle minimums (5/10-piece lines can't be reduced or partly
     removed there). Adding to cart only updates the header count.
     ============================================================ */
  const drawer = document.querySelector('[data-vw-cart-drawer]');
  const scrim = document.querySelector('[data-vw-cart-scrim]');

  function cartUrl() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart';
  }

  function goToCart() {
    window.location.href = cartUrl();
  }

  function closeCart() {
    drawer?.classList.remove('vw-cart--open');
    scrim?.classList.remove('vw-cart-scrim--open');
    drawer?.setAttribute('aria-hidden', 'true');
  }

  // Delegated, so it also catches buttons that are rendered or shown
  // after page load (e.g. the "View cart" button after a 5-piece add).
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-vw-cart-open]');
    if (!opener) return;
    e.preventDefault();
    e.stopPropagation();
    goToCart();
  }, true);
  document.querySelectorAll('[data-vw-cart-close]').forEach((b) => b.addEventListener('click', closeCart));
  scrim?.addEventListener('click', closeCart);
  closeCart();

  // Standard Horizon product-form add-to-cart flows fire this native event,
  // carrying the added quantity directly in its payload. Use that to update
  // the header count INSTANTLY (no network wait, so it can't race or glitch),
  // then reconcile with the server shortly after for absolute correctness.
  document.addEventListener('cart:update', (e) => {
    if (e.detail?.data?.didError) return;
    const itemCount = e.detail?.data?.itemCount;
    const comingFromProductForm = e.detail?.data?.source === 'product-form-component';
    if (typeof itemCount === 'number') {
      setCartCount(comingFromProductForm ? getCartCount() + itemCount : itemCount);
    }
    refreshCount();
  });

  function getCartCount() {
    const cnt = document.querySelector('[data-vw-cart-count]');
    const n = cnt ? parseInt(cnt.textContent || '0', 10) : 0;
    return Number.isFinite(n) ? n : 0;
  }

  function setCartCount(count) {
    const cnt = document.querySelector('[data-vw-cart-count]');
    if (cnt) {
      if (count > 0) { cnt.removeAttribute('hidden'); cnt.textContent = count; }
      else cnt.setAttribute('hidden', '');
    }
    const cntInline = document.querySelector('[data-vw-cart-count-inline]');
    if (cntInline) cntInline.textContent = count;
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-vw-add-form]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then((r) => r.json())
      .then((added) => {
        // added.quantity is the quantity of THIS line just added — bump the
        // badge instantly, same as the native product-form path above.
        if (added && typeof added.quantity === 'number') {
          setCartCount(getCartCount() + added.quantity);
        }
        refreshCount();
      })
      .catch((err) => console.warn('[VW] add failed', err));
  });

  // Legacy drawer line controls (+ / − / Remove). The drawer never opens
  // now, but as a safety net these refuse to touch bundle lines (anything
  // carrying a _BundleSize property, e.g. the 5-piece funky knits), so a
  // bundle can never be reduced below its minimum from here.
  document.addEventListener('click', async (e) => {
    const line = e.target.closest('[data-vw-cart-line]');
    if (!line) return;
    const key = line.getAttribute('data-line-key');
    const qtyEl = line.querySelector('[data-vw-cart-qty]');
    const cur = parseInt(qtyEl?.textContent || '1', 10);
    let next = null;
    if (e.target.closest('[data-vw-cart-inc]')) next = cur + 1;
    else if (e.target.closest('[data-vw-cart-dec]')) next = Math.max(0, cur - 1);
    else if (e.target.closest('[data-vw-cart-remove]')) next = 0;
    if (next == null) return;
    e.preventDefault();
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const item = (cart.items || []).find((it) => it.key === key);
      if (item && item.properties && item.properties._BundleSize) {
        goToCart();
        return;
      }
    } catch (err) {
      return;
    }
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: next }),
    });
    refreshCount();
  });

  /**
   * Fetches /cart.js and updates every count/total/resell element on the
   * page. Fast, single request — this is what confirms "item added" to
   * the customer, via the header cart bubble.
   */
  async function refreshCount() {
    try {
      const r = await fetch('/cart.js');
      const cart = await r.json();
      applyShownCount(cart.item_count - postageQty(cart));
      const sub = document.querySelector('[data-vw-cart-subtotal]');
      if (sub) sub.textContent = money(cart.total_price, cart.currency);
      const re = document.querySelector('[data-vw-cart-resell]');
      if (re) {
        const lo = Math.round(cart.total_price * 2.4 / 100);
        const hi = Math.round(cart.total_price * 3 / 100);
        re.textContent = `£${lo}–${hi}`;
      }
      return cart;
    } catch (e) {
      console.warn('[VW] cart count refresh failed', e);
    }
  }

  // ---------- Bundle builder postage (retired) ----------
  // UK delivery is free on every order and builder piece prices now include
  // postage, so the old £5.45 postage line is never added. syncBuilderPostage
  // still runs so it strips any postage line left over in an existing cart.
  const POSTAGE_VARIANT_ID = 59612394848588;
  const POSTAGE_HANDLE = 'bundle-builder-postage';

  function isPostageLine(item) {
    return item && (item.variant_id === POSTAGE_VARIANT_ID || item.handle === POSTAGE_HANDLE);
  }

  function isBuilderLine(item) {
    if (!item || isPostageLine(item)) return false;
    if (item.properties && item.properties._BundleSize) return true;
    return typeof item.handle === 'string' && /-bundle-item$/.test(item.handle);
  }

  function postageQty(cart) {
    return (cart.items || []).filter(isPostageLine).reduce((n, it) => n + it.quantity, 0);
  }

  // Returns true if it changed the cart.
  async function syncBuilderPostage(cart, doFetch) {
    const f = doFetch || window.fetch;
    const items = cart.items || [];
    const needs = false; // postage is included in piece prices now
    const lines = items.filter(isPostageLine);
    const have = lines.reduce((n, it) => n + it.quantity, 0);
    const post = (url, body) => f(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (needs && have === 1 && lines.length === 1) return false;
    if (!needs && have === 0) return false;
    if (needs && have === 0) {
      await post('/cart/add.js', { items: [{ id: POSTAGE_VARIANT_ID, quantity: 1 }] });
      return true;
    }
    // Wrong quantity, duplicate lines, or no builder pieces left: reset.
    for (let i = 0; i < lines.length; i++) {
      const keep = needs && i === 0 ? 1 : 0;
      await post('/cart/change.js', { id: lines[i].key, quantity: keep });
    }
    return true;
  }
  window.VWBuilderPostage = { sync: syncBuilderPostage, isBuilderLine, isPostageLine, VARIANT_ID: POSTAGE_VARIANT_ID };

  // Any add to cart (bundle builder, 5-piece knits, product forms) goes
  // through /cart/add.js. Once it succeeds, top the postage line up or remove
  // it before the caller carries on, so the builder's jump straight to
  // checkout already includes it.
  let onCartChanged = null;
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async function (input, init) {
    const res = await nativeFetch(input, init);
    try {
      const url = typeof input === 'string' ? input : (input instanceof URL ? input.href : (input && input.url) || '');
      const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method === 'POST' && /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url) && res.ok && !window.__vwPostageSyncing) {
        window.__vwPostageSyncing = true;
        try {
          const cart = await nativeFetch('/cart.js').then((r) => r.json());
          await syncBuilderPostage(cart, nativeFetch);
        } finally {
          window.__vwPostageSyncing = false;
        }
        if (onCartChanged) onCartChanged();
      }
    } catch (err) {
      console.warn('[VW] postage sync failed', err);
    }
    return res;
  };

  // Item counts shown to the customer leave the postage line out.
  let lastShownCount = null;
  function applyShownCount(shown) {
    lastShownCount = shown;
    const text = String(shown);
    const cnt = document.querySelector('[data-vw-cart-count]');
    if (cnt) {
      if (shown > 0) { cnt.removeAttribute('hidden'); if (cnt.textContent !== text) cnt.textContent = text; }
      else cnt.setAttribute('hidden', '');
    }
    document.querySelectorAll('[data-vw-cart-count-inline], .cart-bubble__text-count').forEach((el) => {
      if (el.textContent.trim() !== text) el.textContent = text;
    });
  }

  // The page arrives with Shopify's own count (postage included), so
  // correct it once on load when the cart isn't empty.
  (function correctCountOnLoad() {
    const cnt = document.querySelector('[data-vw-cart-count]');
    const n = cnt ? parseInt(cnt.textContent || '0', 10) : 0;
    if (!n) return;
    nativeFetch('/cart.js').then((r) => r.json())
      .then((cart) => applyShownCount(cart.item_count - postageQty(cart)))
      .catch(() => {});
  })();

  // ---------- Cart page: show postage in the summary, not the item list ----------
  if (/\/cart\/?$/.test(location.pathname)) {
    const style = document.createElement('style');
    style.textContent = ''
      + 'tr.cart-items__table-row:has(a[href*="/products/' + POSTAGE_HANDLE + '"]){display:none!important;}'
      + '.vw-postage-row{display:flex;justify-content:space-between;align-items:flex-start;gap:12px;padding:10px 0;margin-bottom:6px;border-bottom:1px solid rgba(255,255,255,.08);}'
      + '.vw-postage-row__label{display:flex;flex-direction:column;gap:2px;font-size:14px;font-weight:600;color:#fff;}'
      + '.vw-postage-row__label small{font-size:12px;font-weight:500;color:rgba(255,255,255,.55);}'
      + '.vw-postage-row__value{font-size:14px;font-weight:700;color:#fff;white-space:nowrap;}';
    document.head.appendChild(style);

    let postagePence = 0;
    let currency = 'GBP';
    const drawPostageRow = () => {
      // Backup for browsers without :has() support: hide the postage product row.
      document.querySelectorAll('a[href*="/products/' + POSTAGE_HANDLE + '"]').forEach((a) => {
        const tr = a.closest('tr');
        if (tr && tr.style.display !== 'none') tr.style.display = 'none';
      });
      document.querySelectorAll('.cart-totals').forEach((totals) => {
        let row = totals.querySelector('.vw-postage-row');
        if (!postagePence) { if (row) row.remove(); return; }
        if (!row) {
          row = document.createElement('div');
          row.className = 'vw-postage-row';
          const label = document.createElement('span');
          label.className = 'vw-postage-row__label';
          label.append('Bundle builder postage');
          const small = document.createElement('small');
          small.textContent = 'Tracked 48 · once per order';
          label.append(small);
          const value = document.createElement('span');
          value.className = 'vw-postage-row__value';
          row.append(label, value);
          const anchor = totals.querySelector('.cart-totals__container');
          totals.insertBefore(row, anchor || null);
        }
        const value = row.querySelector('.vw-postage-row__value');
        const text = money(postagePence, currency);
        if (value.textContent !== text) value.textContent = text;
      });
    };
    const loadPostage = async () => {
      const cart = await nativeFetch('/cart.js').then((r) => r.json());
      currency = cart.currency || 'GBP';
      postagePence = (cart.items || []).filter(isPostageLine).reduce((n, it) => n + it.final_line_price, 0);
      applyShownCount(cart.item_count - postageQty(cart));
      drawPostageRow();
      return cart;
    };

    // Fix the cart up on load (e.g. the last builder bundle was just
    // removed), reloading once so the rows and totals are right.
    nativeFetch('/cart.js').then((r) => r.json()).then(async (cart) => {
      if (await syncBuilderPostage(cart, nativeFetch)) {
        let tries = 0;
        try { tries = parseInt(sessionStorage.getItem('vwPostageReload') || '0', 10) || 0; } catch (e) {}
        if (tries < 2) {
          try { sessionStorage.setItem('vwPostageReload', String(tries + 1)); } catch (e) {}
          location.reload();
          return;
        }
      }
      try { sessionStorage.removeItem('vwPostageReload'); } catch (e) {}
      await loadPostage();
    }).catch((err) => console.warn('[VW] postage sync failed', err));

    // Make sure the postage line is right before the customer leaves for
    // checkout, in case the cart was changed somewhere this page couldn't see
    // (another tab, a link). Returns true if it had to fix the cart.
    const checkPostageNow = async () => {
      try {
        const cart = await nativeFetch('/cart.js').then((r) => r.json());
        return await syncBuilderPostage(cart, nativeFetch);
      } catch (err) {
        console.warn('[VW] postage check failed', err);
        return false;
      }
    };
    const checkoutUrl = () => ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'checkout';

    // The cart form's "Check out" button submits the form (after any terms
    // checkbox has allowed it): hold the submit, check, then go to checkout.
    document.addEventListener('submit', async (e) => {
      const submitter = e.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      await checkPostageNow();
      window.location.href = checkoutUrl();
    }, true);

    // Plain checkout links on the cart page get the same check.
    let linkChecked = false;
    document.addEventListener('click', async (e) => {
      const link = e.target.closest && e.target.closest('a[href*="/checkout"]');
      if (!link || linkChecked) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      await checkPostageNow();
      linkChecked = true;
      setTimeout(() => { linkChecked = false; }, 4000);
      link.click();
    }, true);

    // Coming back to this tab: the cart may have changed elsewhere.
    const recheckOnReturn = async () => {
      if (document.visibilityState !== 'visible') return;
      if (await checkPostageNow()) { location.reload(); return; }
      loadPostage().catch(() => {});
    };
    document.addEventListener('visibilitychange', recheckOnReturn);
    window.addEventListener('pageshow', (e) => { if (e.persisted) recheckOnReturn(); });

    // Re-read the postage after any cart change on this page...
    onCartChanged = () => { loadPostage().catch(() => {}); };
    // ...and put the row back whenever the cart re-renders its summary
    // (cheap: no network, only touches the page if the row is missing).
    let pending = null;
    new MutationObserver(() => {
      if (pending) return;
      pending = setTimeout(() => {
        pending = null;
        drawPostageRow();
        if (lastShownCount !== null) applyShownCount(lastShownCount);
      }, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function money(cents, currency) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: currency || 'GBP',
      minimumFractionDigits: 2,
    }).format(cents / 100);
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (window.lucide) window.lucide.createIcons();
  });
})();
